import { render, staticRenderFns } from "./CzHead2.vue?vue&type=template&id=174139a7&scoped=true&"
import script from "./CzHead2.vue?vue&type=script&lang=js&"
export * from "./CzHead2.vue?vue&type=script&lang=js&"
import style0 from "./CzHead2.vue?vue&type=style&index=0&id=174139a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174139a7",
  null
  
)

export default component.exports